import { Pipe, PipeTransform } from '@angular/core';
import {Product} from '../types/models';
import {ProductService} from '../services/customer/product.service';

// name of a product without brand and amount (see ProductService.getDisplayName)
@Pipe({
  name: 'productName'
})
export class ProductNamePipe implements PipeTransform {

  constructor(private productService: ProductService) {
  }

  transform(product: Product): string {
    return this.productService.getDisplayName(product);
  }

}
